if (!customElements.get('sey-picks')) {
  customElements.define(
    'sey-picks',
    class SeyPicks extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-sey-picks-panel]'));
        this.prevButton = this.querySelector('[data-sey-picks-prev]');
        this.nextButton = this.querySelector('[data-sey-picks-next]');

        this.onTabClick = this.onTabClick.bind(this);
        this.onTabKeydown = this.onTabKeydown.bind(this);
        this.onNavClick = this.onNavClick.bind(this);
        this.onSlideChanged = this.onSlideChanged.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick);
          tab.addEventListener('keydown', this.onTabKeydown);
        });

        this.prevButton?.addEventListener('click', this.onNavClick);
        this.nextButton?.addEventListener('click', this.onNavClick);

        this.panels.forEach((panel) => {
          const slider = panel.querySelector('slider-component');
          slider?.addEventListener('slideChanged', this.onSlideChanged);
          slider?.querySelector('[id^="Slider-"]')?.addEventListener('scroll', this.onSlideChanged, { passive: true });
        });

        document.addEventListener('shopify:block:select', this.onBlockSelect);

        requestAnimationFrame(() => this.syncNav());
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.onTabClick);
          tab.removeEventListener('keydown', this.onTabKeydown);
        });
        this.prevButton?.removeEventListener('click', this.onNavClick);
        this.nextButton?.removeEventListener('click', this.onNavClick);
        this.panels.forEach((panel) => {
          const slider = panel.querySelector('slider-component');
          slider?.removeEventListener('slideChanged', this.onSlideChanged);
          slider?.querySelector('[id^="Slider-"]')?.removeEventListener('scroll', this.onSlideChanged);
        });
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get activePanel() {
        return this.panels.find((panel) => !panel.hasAttribute('hidden')) || this.panels[0];
      }

      get activeSlider() {
        return this.activePanel?.querySelector('slider-component');
      }

      onTabClick(event) {
        const tab = event.currentTarget;
        this.activate(tab.getAttribute('aria-controls'));
      }

      onTabKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        if (index < 0) return;

        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;

        event.preventDefault();
        this.tabs[next].focus();
        this.activate(this.tabs[next].getAttribute('aria-controls'));
      }

      onNavClick(event) {
        const name = event.currentTarget.hasAttribute('data-sey-picks-prev') ? 'previous' : 'next';
        this.activeSlider?.querySelector(`button[name="${name}"]`)?.click();
      }

      onSlideChanged() {
        this.syncNav();
      }

      onBlockSelect(event) {
        if (!event.target || !this.contains(event.target)) return;
        const tab = event.target.closest('[role="tab"]');
        if (tab) {
          this.activate(tab.getAttribute('aria-controls'));
          return;
        }
        const panel = event.target.closest('[data-sey-picks-panel]');
        if (panel) this.activate(panel.id);
      }

      activate(panelId) {
        if (!panelId) return;

        this.tabs.forEach((tab) => {
          const selected = tab.getAttribute('aria-controls') === panelId;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          if (panel.id === panelId) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });

        const slider = this.activeSlider;
        const track = slider?.querySelector('[id^="Slider-"]');
        if (track) track.scrollLeft = 0;
        requestAnimationFrame(() => {
          slider?.resetPages?.();
          this.syncNav();
        });
      }

      syncNav() {
        if (!this.prevButton || !this.nextButton) return;
        const slider = this.activeSlider;
        const prev = slider?.querySelector('button[name="previous"]');
        const next = slider?.querySelector('button[name="next"]');
        this.prevButton.disabled = !prev || prev.hasAttribute('disabled');
        this.nextButton.disabled = !next || next.hasAttribute('disabled');
      }
    }
  );
}
